import { cn } from "../../lib/utils";

interface DividerProps {
  className?: string;
}

export function Divider({ className }: DividerProps = {}) {
  return <div className={cn("border-alabastergrey border-t", className)} />;
}
